// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
    color: #3f3f3f!important;
}

.table>:not(:first-child) {
    border-top: 1px solid currentColor!important;
}

.tableWrap {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/CustomTable.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".table {\r\n    color: #3f3f3f!important;\r\n}\r\n\r\n.table>:not(:first-child) {\r\n    border-top: 1px solid currentColor!important;\r\n}\r\n\r\n.tableWrap {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
